import React, { useEffect, useState, useMemo } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import { Link, useHistory } from 'react-router-dom'
import moment from 'moment'
import '../../fonts/fonts.css'
import ModalConfirm from '../../components/ModalConfirm'
import { deleteAgencySaga, refreshAgenciesSaga, getDashboardSaga, getFilteredAgenciesSaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { deleteAgency, refreshAgencies, getDashboard, getFilteredAgencies } from '../App/actions'
import ShouldRefreshAgencies from '../ShouldRefreshAgencies/index'
import AgencyAvatar from '../../images/firstAgency.svg'
import AddStudent from '../../images/Add.svg'
import config from '../../config/configurator'
import { Loader, Bg, FirstContainer, ContainerFirstAgency, TextFirstCSV, AvatarContainer, ButtonImport, ButtonCreate, ImportImg, ImportText } from './styledComponents'
import {
  TablePageLayout, FilterRow, FilterField, FilterFieldLabel, FilterSearchBox, FilterIconBtn, InlineDateFilter,
  TableCard, TableScroll, StyledTable, STHead, STH, STBody, STR, STD,
  PlayerCellWrapper, InitialBubble, PlayerRowLink,
  TableActions2, TActionBtn, NoneText,
  EmptyStateCard, EmptyStateIcon, EmptyStateSubText,
} from '../SimuPlayers/styledComponents'
import PageHeader from '../../components/PageHeader'
import agencyIcon from '../../images/UiAgences.svg'
import UiEdit from '../../images/edit.svg'
import UiDelRed from '../../images/closeRed.svg'
import SearchIcon from '../../images/search.svg'
import ResetIcon from '../../images/delete.svg'

const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return (parts[0]?.[0] || '?').toUpperCase()
  return ((parts[0]?.[0] || '') + (parts[parts.length - 1]?.[0] || '')).toUpperCase()
}

const Agency = () => {
  const dispatch  = useDispatch()
  const history   = useHistory()
  const agencies  = useSelector(s => s.toJS().global.agencies)
  const token     = useSelector(s => s.toJS().global.agencytoken)
  const players      = useSelector(s => s.toJS().global.players)
  const simuPlayers  = useSelector(s => s.toJS().global.simuPlayers)
  const isloading    = useSelector(s => s.toJS().global.loading)

  const [currentAgencyId, setCurrentAgencyId] = useState('')
  const [showModal,  setShowModal]  = useState(false)
  const [modalText,  setModalText]  = useState('')
  const [modalName,  setModalName]  = useState('')
  const [filters,    setFilters]    = useState({ agency: '', email: '', date: '' })
  const [activatedButton, setActivatedButton] = useState(false)
  const [searchExecuted, setSearchExecuted] = useState(false)

  useEffect(() => {
    dispatch(getDashboard(token))
    dispatch(refreshAgencies(token))
    // eslint-disable-next-line
  }, [])

  const confirmDelete = (id, agency) => {
    setShowModal(true)
    setModalText("Attention, vous allez supprimer definitiement l'agence ")
    setModalName(agency)
    setCurrentAgencyId(id)
  }

  const deleteCurrAgency = (id) => {
    dispatch(deleteAgency(token, id))
    setTimeout(() => { history.go(0) }, 500)
  }

  const handleClickFilters = (e, type) => {
    const updated = { ...filters }
    if (type === 'agency') updated.agency = e.target.value
    else if (type === 'email') updated.email = e.target.value
    else if (type === 'date') updated.date = e.target.value
    setFilters(updated)
    setActivatedButton(true)
  }

  const handleClickFindAgencies = () => {
    dispatch(getFilteredAgencies(filters, agencies, token))
    setSearchExecuted(true)
    const hasFilters = filters.agency || filters.email || filters.date
    setActivatedButton(hasFilters)
  }

  const resetFilters = () => {
    setFilters({ agency: '', email: '', date: '' })
    setActivatedButton(false)
    setSearchExecuted(false)
    dispatch(refreshAgencies(token))
  }

  const rows = useMemo(() => {
    if (!agencies) return []
    return agencies
      .map(agency => {
        const id = agency.agencyId || agency._id
        const allStudents = config.features.simu
          ? (simuPlayers || []).filter(v => v.agencyId === agency._id)
          : (players    || []).filter(v => v.agencyId === agency._id)
        const count       = allStudents.length
        const activeCount = config.features.simu
          ? allStudents.filter(v => v.status !== 0).length
          : count
        const evalLabel = agency.evalScaleDisplay === 'hours' ? 'Heures'
          : agency.evalScaleDisplay === 'seq' ? 'Séquences'
          : null
        return {
          id,
          name:       agency.agencyname || agency.agencyName,
          email:      agency.notificationEmail || null,
          count,
          activeCount,
          evalLabel,
          date:       moment(agency.dateCreation).format('DD/MM/YYYY'),
        }
      })
  }, [agencies, simuPlayers, players])

  if (!agencies || isloading === true) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Loader />
      </div>
    )
  }

  const NoAgencies = () => (
    <Bg>
      <ShouldRefreshAgencies token={token} />
      <FirstContainer>
        <ContainerFirstAgency>
          <AvatarContainer><img alt='' src={AgencyAvatar} /></AvatarContainer>
          <TextFirstCSV>Vous pouvez <b>creer une agence</b> avec votre console de gestion</TextFirstCSV>
          <ButtonImport>
            <ButtonCreate to='/agency/create' style={{ width: '201px' }}>
              <ImportImg src={AddStudent} />
              <ImportText>Creer une agence</ImportText>
            </ButtonCreate>
          </ButtonImport>
        </ContainerFirstAgency>
      </FirstContainer>
    </Bg>
  )

  const FilteredEmpty = () => (
    <FirstContainer>
      <EmptyStateCard>
        <EmptyStateIcon aria-hidden='true'>?</EmptyStateIcon>
        <TextFirstCSV>Aucune agence ne correspond à la recherche.</TextFirstCSV>
        <EmptyStateSubText>Essayez de modifier un ou plusieurs filtres, puis relancez la recherche.</EmptyStateSubText>
      </EmptyStateCard>
    </FirstContainer>
  )

  if (agencies.length === 0 && !searchExecuted) {
    return <NoAgencies />
  }

  return (
    <Bg>
      <ShouldRefreshAgencies token={token} />
      <ModalConfirm
        show={showModal}
        name={modalName}
        text={modalText}
        confirmText='Supprimer'
        confirm={() => { deleteCurrAgency(currentAgencyId); setShowModal(false) }}
        cancel={() => setShowModal(false)}
      />

      <PageHeader
        icon={agencyIcon}
        title='Les Agences'
        subtitle={`${agencies.length} agence${agencies.length > 1 ? 's' : ''}`}
      />

      <TablePageLayout>
        <FilterRow>
          <FilterField>
            <FilterFieldLabel>Agence</FilterFieldLabel>
            <FilterSearchBox>
              <img src={SearchIcon} alt='' />
              <input
                onChange={e => handleClickFilters(e, 'agency')}
                value={filters.agency}
                placeholder='Chercher une agence'
              />
            </FilterSearchBox>
          </FilterField>

          <FilterField>
            <FilterFieldLabel>Email</FilterFieldLabel>
            <FilterSearchBox>
              <img src={SearchIcon} alt='' />
              <input
                onChange={e => handleClickFilters(e, 'email')}
                value={filters.email}
                placeholder='Chercher un email'
              />
            </FilterSearchBox>
          </FilterField>

          <FilterField>
            <FilterFieldLabel>Date</FilterFieldLabel>
            <InlineDateFilter
              value={filters.date}
              type='date'
              onChange={e => handleClickFilters(e, 'date')}
            />
          </FilterField>

          {activatedButton && (
            <FilterIconBtn onClick={handleClickFindAgencies} title='Rechercher'>
              <img src={SearchIcon} alt='' />
            </FilterIconBtn>
          )}
          {activatedButton && (
            <FilterIconBtn onClick={resetFilters} title='Réinitialiser'>
              <img src={ResetIcon} alt='' />
            </FilterIconBtn>
          )}
        </FilterRow>

        {(searchExecuted && rows.length === 0) ? <FilteredEmpty /> : (
        <TableCard>
          <TableScroll>
            <StyledTable>
              <STHead>
                <tr>
                  <STH style={{ width: '22%' }}>Agence</STH>
                  <STH style={{ width: '18%' }}>Email</STH>
                  <STH style={{ width: '10%', textAlign: 'center' }}>Élèves</STH>
                  <STH style={{ width: '10%', textAlign: 'center' }}>Actifs</STH>
                  <STH style={{ width: '11%', textAlign: 'center' }}>Affichage éval</STH>
                  <STH style={{ width: '11%', textAlign: 'center' }}>Date de création</STH>
                  <STH style={{ width: '8%',  textAlign: 'center' }}>Actions</STH>
                </tr>
              </STHead>
              <STBody>
                {rows.map(row => (
                  <STR key={row.id}>
                    {/* Agence */}
                    <STD>
                      <PlayerCellWrapper>
                        <InitialBubble>{getInitials(row.name)}</InitialBubble>
                        <PlayerRowLink to={`agency/edit/${row.id}`}>{row.name}</PlayerRowLink>
                      </PlayerCellWrapper>
                    </STD>
                    {/* Email */}
                    <STD>
                      {row.email
                        ? <span style={{ fontFamily: 'Poppins', fontSize: '0.78rem', color: '#6B7280', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.email}</span>
                        : <NoneText>—</NoneText>
                      }
                    </STD>
                    {/* Élèves total */}
                    <STD style={{ textAlign: 'center' }}>
                      <span style={{ fontFamily: 'Poppins', fontSize: '0.875rem', color: '#374151' }}>{row.count}</span>
                    </STD>
                    {/* Élèves actifs */}
                    <STD style={{ textAlign: 'center' }}>
                      <span style={{ fontFamily: 'Poppins', fontSize: '0.875rem', color: '#16A34A', fontWeight: 600 }}>{row.activeCount}</span>
                    </STD>
                    {/* Affichage éval */}
                    <STD style={{ textAlign: 'center' }}>
                      {row.evalLabel
                        ? <span style={{ fontFamily: 'Poppins', fontSize: '0.78rem', color: '#374151' }}>{row.evalLabel}</span>
                        : <NoneText>—</NoneText>
                      }
                    </STD>
                    {/* Date */}
                    <STD style={{ textAlign: 'center' }}>
                      <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280', whiteSpace: 'nowrap' }}>{row.date}</span>
                    </STD>
                    <STD style={{ textAlign: 'center' }}>
                      <TableActions2>
                        <TActionBtn as={Link} to={`agency/edit/${row.id}`} title='Modifier'>
                          <img src={UiEdit} alt='' />
                        </TActionBtn>
                        <TActionBtn
                          $danger
                          onClick={() => confirmDelete(row.id, row.name)}
                          title='Supprimer'
                        >
                          <img src={UiDelRed} alt='' />
                        </TActionBtn>
                      </TableActions2>
                    </STD>
                  </STR>
                ))}
              </STBody>
            </StyledTable>
          </TableScroll>
        </TableCard>
        )}
      </TablePageLayout>
    </Bg>
  )
}

const withConnect = connect(null, null)
const withDelete = injectSaga({ key: 'deleteAgency', saga: deleteAgencySaga })
const withSagaRefreshAg = injectSaga({ key: 'refreshAgencies', saga: refreshAgenciesSaga })
const withDashboard = injectSaga({ key: 'getDashboard', saga: getDashboardSaga })
const withFilteredAgencies = injectSaga({ key: 'getFilteredAgencies', saga: getFilteredAgenciesSaga })
const arg = compose(withDelete, withSagaRefreshAg, withDashboard, withFilteredAgencies, withConnect)(Agency)

export default arg
